goog.provide('el8.util.amplitude.ccdaImportHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Log when the a specific section is imported from a CCDA via carequality dialog 
 * @param {string} section section being imported from CCDA
 */
 el8.util.amplitude.logCcdaImportSection = function(section) {
    try {
        el8.util.amplitude.logEvent('CCDA Import - import CCDA section', { 'CCDA segment': section });
    } catch (err) {
        console.warn(err);
    }
}